import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import firebase from 'firebase/app'
import 'firebase/auth'
import firebaseConfig from '../firebase.config'

Vue.config.productionTip = false

firebase
    .initializeApp( firebaseConfig )

firebase
    .auth()
    .signInAnonymously()
    .catch( error => {
        console.log( error.code, error.message )
    })

firebase
    .auth()
    .onAuthStateChanged( user => {

        new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount('#app')

        store.commit( 'uid', user ? user.uid : null )
        store.commit( 'anon', user ? user.isAnonymous : null )
        
        console.log( store.state.uid, store.state.anon )
    }
)